/**
 * Dates i hores entre el servidor i la pantalla.
 *
 * El servidor treballa sempre en UTC (`datetime.utcnow()`) i les serialitza
 * SENSE marca de fus: «2026-08-05T08:48:07». El navegador, davant d'una cadena
 * així, l'interpreta com a hora LOCAL, de manera que fins al 05/08/2026 la
 * pantalla d'entregues ensenyava les hores dues hores endarrerides a l'estiu
 * («ha començat a les 8:48» quan eren les 10:48).
 *
 * Amb les hores d'inici i final d'una missió això deixa de ser una molèstia i
 * passa a ser greu: un examen programat per a les 12:00 s'obriria a les 14:00.
 *
 * Regla d'aquest fitxer: el que ve del servidor és UTC encara que no ho digui, i
 * el que escriu l'instructor és hora local d'aquí.
 */

/** Cadena del servidor → objecte Date, o null. */
export function desDeUTC(valor) {
  if (!valor) return null;
  const teFus = /([zZ]|[+-]\d{2}:?\d{2})$/.test(valor);
  const data = new Date(teFus ? valor : `${valor}Z`);
  return Number.isNaN(data.getTime()) ? null : data;
}

/** Cadena del servidor → text llegible en hora local. */
export function mostraDataHora(valor, siNoHiHa = '') {
  const data = desDeUTC(valor);
  return data ? data.toLocaleString() : siNoHiHa;
}

/** Cadena del servidor → valor per a un <input type="datetime-local">. */
export function aInputLocal(valor) {
  const data = desDeUTC(valor);
  if (!data) return '';
  const dosDigits = (n) => String(n).padStart(2, '0');
  return (
    `${data.getFullYear()}-${dosDigits(data.getMonth() + 1)}-${dosDigits(data.getDate())}` +
    `T${dosDigits(data.getHours())}:${dosDigits(data.getMinutes())}`
  );
}

/**
 * Valor d'un <input type="datetime-local"> → cadena per al servidor.
 *
 * Es retorna UTC i **sense** la Z final. Amb la Z, Pydantic construiria una data
 * amb fus i el servidor la compararia amb `datetime.utcnow()`, que no en té:
 * Python es nega a comparar-les i la petició acabaria en un error 500.
 */
export function aUTCDelServidor(valor) {
  if (!valor) return null;
  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return null;
  return data.toISOString().slice(0, 19);
}
